export default "__VITE_ASSET__CtqX9Pba__"